import Tooltip from 'Components/Atoms/Tooltip/Tooltip';
import { useState } from 'react';
import { connect } from 'react-redux';
import { StoreState } from 'Store/Reducers';
import styles from '../ContactHeader.module.sass';

const ContactHeaderItemLabel = ({
    values, list,
    
    ...props
}: ContactHeaderItemLabelProps) => {
    const [tooltipRef, setTooltipRef] = useState<any>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const handleTooltipHover = (value: boolean) => () => setShowTooltip(value);

    return <span
        ref={setTooltipRef}
        onMouseEnter={handleTooltipHover(true)}
        onMouseLeave={handleTooltipHover(false)}
        className={styles['contactheader__list-item-primary']}
    >({values?.length} {
        values?.length === 1
        ? 'Afdeling'
        : 'Afdelingen'
    })
        {
            showTooltip &&
            <Tooltip ref={tooltipRef}>
                {
                    values?.map((j: any, idx: any) => 
                        <span>
                            { idx !== 0 && ','} { list?.find(i => i?.value === j)?.label }
                        </span>
                    )
                }
            </Tooltip>
        }
    </span>;
}

interface Props {
    values: any[]
    list: any[]
}

const mapState = (state: StoreState, props: Props) => ({

});

const mapDispatch = {

}

type ContactHeaderItemLabelProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(ContactHeaderItemLabel);